import { langMessages } from "./lang"
import { multilangMessages } from "./multilang"
import { profileMessages } from "./profile"
import { tabletInfoMessages } from "./tabletInfo"

export const messages = {
  sites: {
    CAT: {
      title: "AI Text Translator",
      description: "Short texts for instant translation and storage? Click the arrow, then paste or type your text."
    },
    addProject: {
      title: "AI File Translator",
      description: "Select to automatically translate your documents."
    },
    addEnhanceProject: {
      title: "Editor",
      description: "Select to translate and enhance your documents. Put the finishing touches on your text."
    },
    addTrustmineProject: {
      title: "Editor+",
      description:
        "Select to translate, enhance, and trust mine your documents. Work in tandem with your colleague as an Enhancer or a Trust Miner."
    },
    bi: {
      title: "Business Intelligence",
      description:
        "Total project completed, total words translated, projects per language pair, recycled linguistic assets, and total phrases anonymized."
    },
    kmGenerator: {
      title: "Exfluency CREATE"
    },
    kmChat: {
      title: "Exfluency ASK"
    }
  },
  common: {
    download: "Download",
    openInEditor: "Open in editor",
    quote: {
      seeQuote: "See quote",
      stillQuoting: "Quoting",
      quoteFor: "QUOTE FOR:",
      goAhead: "Go ahead",
      decline: "Decline",
      downloadPdf: "Download PDF"
    },
    langFrom: "From",
    langFromMobile: "Translate from",
    langTo: "To",
    langToMobile: "Translate into",
    targetLanguageLockedFinalRedaction:
      "Final redaction edits the document in one language only. The target language always matches the source language.",
    firstStage: "Select Enhancer",
    secondStage: "Select Trust Miner",
    translate: {
      title: "Translate",
      copy: "Copied to clipboard",
      created: "New asset added to the Asset Store",
      back: "New translation",
      createNewAsset: "Save to reuse",
      error: "Failed to translate text",
      createError: "Failed to create asset",
      notSupported: "This language pair is not supported",
      anonymized: "[Anonymized text] ",
      selectLangs: "Select languages to translate",
      typeText: "Type text to translate"
    },
    inputLimit: "Translated text can't be longer than {{val}} characters.",
    document: {
      languages: "Languages",
      inhouseTeam: "Inhouse team",
      title: "Translate file",
      uploadError: "Sorry, but we cannot process your request right now. Please try again later.",
      permissionError:
        "We only allow NGO's to translate file. – Please make sure your company can add charity projects by reaching out to your Exfluency contact.",
      sendWithAnonymizationDescription: "All files will be anonymized to protect your data confidentiality",
      instructions: "Instructions/Reference files",
      taxonomy: "Skillset node/s",
      projectId: "Project ID",
      genre: "Genre",
      community: "Knowledge Base",
      summary: {
        thankYou: "Thank you for submitting the file/s.",
        myFilesInfo: "They will appear in My Files and in the selected Knowledge Base/s.",
        emailInfo: "We will notify you via email when the translated files are ready.",
        notifyQuoted:
          "We will notify you via email when a quote for the file/s is ready to be approved. It will also appear in My Files.",
        translateAnother: "Translate more files",
        goToMyFiles: "Go to My Files"
      }
    },
    files: {
      noFiles: "No files available",
      downloadError: "Sorry, but your document cannot be downloaded yet. Please try again later.",
      QUOTED: "Quoted",
      QUOTING: "Quoting",
      CANCELLED: "Cancelled",
      IN_PROGRESS: "In progress",
      FINISHED: "Finished",
      REJECTED: "Quote rejected",
      completed: "Completed",
      details: {
        ERROR: "Error occured during file translation",
        CANCELLED: "Translation project has been cancelled",
        uploaded: "Uploaded",
        deadline: "Due date"
      }
    },
    assignments: {
      title: "Open Assignments",
      noData: "Nothing is currently assigned to you. Sorry!"
    },
    error: {
      noConnection: "Network connection not available",
      request: {
        index: "Request error",
        400: "Bad Request – Check input data",
        401: "Request is not authorized",
        403: "This operation is not allowed",
        404: "Server is not available",
        414: "Request is too long",
        504: "Connection timed out",
        500: "Unexpected server error",
        502: "Unexpected server error"
      }
    }
  },
  lang: { ...langMessages },
  profile: { ...profileMessages },
  multilang: { ...multilangMessages },
  tabletInfo: { ...tabletInfoMessages }
}

export default messages
